module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_02.ad70b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_02.png
// module id = y2yG
// module chunks = 1